import React from 'react';
import {useSelector} from 'react-redux';

import {labels} from '../../../../../../../../../../util/utils';
import {
	entities as EntityTypes,
	documentTypes,
	groupInvolvementSources
} from '../../../../../../../../../../util/uiconstants';

import ListHeader from '../../../../../../../../../Main/Ares/Common/ListHeader/ListHeader';
import EntityDocuments from '../../../../Common/EntityDocuments';
import CreateEntityForm from '../../../../../../Common/CreateEntityForm/CreateEntityForm';

import Style from './StyledComponentTile';

export default function ComponentTile({component, onCreateDocument}) {
	const handleCreateDocument = () => {
		onCreateDocument && onCreateDocument();
	};

	return (
		<Style className="StyledComponent">
			<ListHeader name={component.name} headerClassName={'styledAccountName'}>
				<CreateEntityForm
					key={`createEntityAccount-${component.id}`}
					createLabel={labels.createGroupInvolvementDocument}
					entityId={EntityTypes.GaComponent}
					objectIds={[component.id]}
					documentTypeId={documentTypes.GROUP_INVOLVEMENT_INDIVIDUAL_COMPONENT}
					source={groupInvolvementSources.groupInvolvementIndex}
					selector={(store) => {
						const ids = store.entityDocuments.allIds?.filter((id) => {
							const entityDocument = store.entityDocuments.byId[id];

							return (
								entityDocument.smartEvidenceSourceId === component.id &&
								entityDocument.documentTypeId === documentTypes.GROUP_INVOLVEMENT_INDIVIDUAL_COMPONENT
							);
						});

						return ids?.map((id) => {
							return store.entityDocuments && store.entityDocuments.byId && store.entityDocuments.byId[id];
						});
					}}
					render={({objectIds, entityForms}) => {
						return <EntityDocuments entityUId={objectIds[0]} documents={entityForms} />;
					}}
					onCreateDocument={handleCreateDocument}
				/>
			</ListHeader>
		</Style>
	);
}
